import { Distributor, Priority } from "../../models/Product";
import { Tenant, TenantType } from "../../models/Tenant";
import { Language } from "../../models/Translation";

export const REQUEST_TENANTS = "REQUEST_TENANTS";
export const REQUEST_TENANT_DISTRIBUTORS = "REQUEST_TENANT_DISTRIBUTORS";
export const REQUEST_TENANT_TYPES = "REQUEST_TENANT_TYPES";
export const REQUEST_TENANT_BRAND_NAMES = "REQUEST_TENANT_BRAND_NAMES";
export const REQUEST_TENANT_PRODUCT_PRIORITIES =
  "REQUEST_TENANT_PRODUCT_PRIORITIES";
export const REQUEST_TENANT_LANGUAGES = "REQUEST_TENANT_LANGUAGES";

export const REQUEST_TENANT_RELOAD = "REQUEST_TENANT_RELOAD";

export interface ReloadTenant {
  type: typeof REQUEST_TENANT_RELOAD;
  payload: boolean;
}

export interface FetchTenants {
  type: typeof REQUEST_TENANTS;
  payload: ReadonlyArray<Tenant>;
}

export interface FetchTenantsDistributors {
  type: typeof REQUEST_TENANT_DISTRIBUTORS;
  payload: ReadonlyArray<Distributor>;
}

export interface FetchTenantTypes {
  type: typeof REQUEST_TENANT_TYPES;
  payload: ReadonlyArray<TenantType>;
}

export interface FetchTenantBrandNames {
  type: typeof REQUEST_TENANT_BRAND_NAMES;
  payload: ReadonlyArray<string>;
}

export interface FetchTenantProductPriorites {
  type: typeof REQUEST_TENANT_PRODUCT_PRIORITIES;
  payload: ReadonlyArray<Priority>;
}

export interface FetchTenantLanguages {
  type: typeof REQUEST_TENANT_LANGUAGES;
  payload: ReadonlyArray<Language>;
}

export interface TenantsState {
  list: ReadonlyArray<Tenant>;
  distributors: ReadonlyArray<Distributor>;
  types: ReadonlyArray<TenantType>;
  brandNames: ReadonlyArray<string>;
  productPriorites: ReadonlyArray<Priority>;
}

export interface CurrentTenantState {
  languages: ReadonlyArray<Language>;
}

export type TenantActionTypes =
  | FetchTenants
  | FetchTenantsDistributors
  | FetchTenantTypes
  | FetchTenantBrandNames
  | FetchTenantProductPriorites
  | FetchTenantLanguages
  | ReloadTenant;
